import { IOffer } from '../../../types/offer';

export function getHouseShareTitle(offer: IOffer) {
  return offer.shareAmount ? offer.shareAmount + ' дома' : 'часть дома';
}
